import React from "react";
import { Icon } from "components";
import { useAuth } from "hooks/useAuth";
import { truckIcon } from "assets";
import { formatDate, formatUah } from "utils/format";

// Позначка «товар у дорозі» з підказкою про очікувані приходи: коли, скільки,
// на яку юрособу і за якою ціною.
// Дані беруться з журналу очікуваного приходу (/supply-report), зіставлені за артикулом
function RecommendationIncomingBadge({ incoming }) {
  const { isAllowed } = useAuth();
  const items = Array.isArray(incoming) ? incoming : [];

  if (items.length === 0) return null;

  // Орієнтовна ціна — закупівельна інформація, показуємо її тим, хто бачить журнал приходу
  const canViewPrice = isAllowed("supply_report:view");

  return (
    <div className="incoming-container">
      <span className="incoming-badge">
        <Icon src={truckIcon} />
      </span>
      <div className="incoming-tooltip" role="tooltip">
        <p className="incoming-tooltip-title">В дорозі</p>
        <ul>
          {items.map((item, index) => (
            <li key={index}>
              <span className="incoming-date">{formatDate(item.arrival_date)}</span>
              <span className="incoming-quantity">{item.quantity} шт</span>
              {item.additional_info && (
                <span className="incoming-entity">{item.additional_info}</span>
              )}
              {canViewPrice && item.estimated_price !== null && (
                <span className="incoming-price">{formatUah(item.estimated_price)}</span>
              )}
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default RecommendationIncomingBadge;
